import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { BaseClassicApiService } from "@core/services/api/classic/base-classic-api.service";
import { LoadingService } from "@core/services/loading.service";
import { UserPostQualityResponse } from "@shared/interfaces/user-post-quality.interface";
import { Observable, shareReplay, tap } from "rxjs";

@Injectable({
  providedIn: "root"
})
export class UserPostQualityApiService extends BaseClassicApiService {
  private readonly cacheMap = new Map<string, Observable<UserPostQualityResponse>>();
  private readonly cacheDuration = 5 * 60 * 1000; // 5 minutes

  constructor(
    public readonly http: HttpClient,
    public readonly loadingService: LoadingService
  ) {
    super(loadingService);
  }

  getUserPostQuality(userId: number, period?: number): Observable<UserPostQualityResponse> {
    const cacheKey = `${userId}-${period || 90}`;
    const cached = this.cacheMap.get(cacheKey);

    if (cached) {
      return cached;
    }

    const url = `${this.baseUrl}/users/${userId}/post-badges/`;
    const params: any = {};
    if (period) {
      params.period = period.toString();
    }

    const request$ = this.http.get<UserPostQualityResponse>(url, { params }).pipe(
      shareReplay(1),
      tap(() => {
        // Clear cache after duration
        setTimeout(() => {
          this.cacheMap.delete(cacheKey);
        }, this.cacheDuration);
      })
    );

    this.cacheMap.set(cacheKey, request$);
    return request$;
  }

  clearCache(): void {
    this.cacheMap.clear();
  }
}
